import { Directive } from '@angular/core';
import {
  BusinessTransportPolicyType,
  getBusinessTransportPolicyTypeLabel,
} from 'src/app/_enums/business/business-transport-policy-type.enum';
import { getPaymentFrequencyLabel } from 'src/app/_enums/payment-frequency.enum';
import { BusinessTransportInsuranceMetadata } from 'src/app/_types/lead.types';

import { BaseMetadataComponent } from '../../base-metadata.component';

@Directive()
export abstract class BusinessTransportMetadataComponentAbstract extends BaseMetadataComponent<BusinessTransportInsuranceMetadata> {
  getPaymentFrequencyLabel = getPaymentFrequencyLabel;

  getBusinessTransportPolicyTypeLabel = getBusinessTransportPolicyTypeLabel;

  hasGeneralInfo(data?: BusinessTransportInsuranceMetadata): boolean {
    if (!data) return false;
    return [
      data.startDate,
      data.contractDuration,
      data.paymentFrequency,
      data.splitPaymentFee,
      data.policyType,
      data.coverages,
      data.limitations,
      data.deductibleByCase,
    ].some((v: any) => v !== null && v !== undefined && v !== '');
  }

  isSectionEmpty(section?: Record<string, any> | null): boolean {
    if (!section) return true;
    const values = Object.values(section);
    if (!values.length) return true;
    return !values.some((v) => v !== null && v !== undefined && v !== '');
  }
}
